import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { API_SOISALAK, API_SOISALAK_UPLOAD } from "../utils";
import { logoutUser } from "actions/AuthAction";
import { useHistory } from "react-router-dom";

function Temuan() {
  const [temuanList, setTemuanList] = useState([]);
  const [modalTambah, setModalTambah] = useState(false);
  const [temuan, setTemuan] = useState("");
  const [idDinas, setIdDinas] = useState("");
  const [tanggalTemuan, setTanggalTemuan] = useState("");
  const [deadline, setDeadline] = useState("");
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [dinasList, setDinasList] = useState([]);
  const [loadingTemuan, setLoadingTemuan] = useState(false);
  const [loadingDinas, setLoadingDinas] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [idUser, setIdUser] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const [temuanEdit, setTemuanEdit] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [temuanToDelete, setTemuanToDelete] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [tahunTemuan, setTahunTemuan] = useState(new Date().getFullYear());
  const [statusUser, setStatusUser] = useState(null);
  const [dinasId, setDinasId] = useState(null);
  const [perangkatDaerah, setPerangkatDaerah] = useState(null);
  const [fileName, setFileName] = useState("");
  const history = useHistory();

  // Generate tahun options untuk filter
  const currentYear = new Date().getFullYear();
  const tahunOptions = [];
  for (let y = currentYear - 1; y <= currentYear + 4; y++) {
    tahunOptions.push(y);
  }

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setIdUser(userData.id || userData.idUser);
      setStatusUser(userData.status);
      setDinasId(userData.idDinas);
      setPerangkatDaerah(userData.perangkatdaerah);
    } else {
      logoutUser(history);
    }
  }, []);

  useEffect(() => {
    if ((idUser, statusUser)) {
      if (statusUser == 3) {
        ambilTemuan();
      } else {
        ambilTemuanDinas();
      }
      ambilDinas();
    }
  }, [idUser, tahunTemuan, statusUser]);

  const ambilTemuan = async () => {
    setLoadingTemuan(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/temuan/tahun/${tahunTemuan}`
      );
      if (res.data.success) {
        setTemuanList(res.data.data);
      } else {
        setTemuanList([]);
      }
    } catch (err) {
      swal("Gagal", "Gagal mengambil data temuan", "error");
      setTemuanList([]);
    }
    setLoadingTemuan(false);
  };

  const ambilTemuanDinas = async () => {
    setLoadingTemuan(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/temuan/dinas/${dinasId}/tahun/${tahunTemuan}`
      );
      if (res.data.success) {
        setTemuanList(res.data.data);
      } else {
        setTemuanList([]);
      }
    } catch (err) {
      swal("Gagal", "Gagal mengambil data temuan", "error");
      setTemuanList([]);
    }
    setLoadingTemuan(false);
  };

  const ambilDinas = async () => {
    setLoadingDinas(true);
    try {
      const res = await axios.get(`${API_SOISALAK}/dinas`);
      if (res.data.success) {
        setDinasList(res.data.data);
      } else {
        setDinasList([]);
      }
    } catch (err) {
      setDinasList([]);
    }
    setLoadingDinas(false);
  };

  const handleTambahTemuan = async () => {
    if (!temuan || !idDinas || !tanggalTemuan || !tahun) {
      swal(
        "Gagal",
        "Temuan, dinas, tanggal temuan, dan tahun wajib diisi",
        "error"
      );
      return;
    }

    setLoadingSubmit(true);
    const formData = new FormData();
    formData.append("temuan", temuan);
    formData.append("idDinas", idDinas);
    formData.append("tanggalTemuan", tanggalTemuan);
    formData.append("deadline", deadline);
    formData.append("idUser", idUser);
    formData.append("tahun", tahun);

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      const res = await axios.post(`${API_SOISALAK}/temuan`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        swal("Sukses", "Temuan berhasil ditambahkan", "success");
        setModalTambah(false);
        setTemuan("");
        setIdDinas("");
        setTanggalTemuan("");
        setDeadline("");
        setTahun(new Date().getFullYear());
        setSelectedFile(null);
        setFileName("");
        if (statusUser == 3) {
          ambilTemuan();
        } else {
          ambilTemuanDinas();
        }
      } else {
        swal("Gagal", res.data.message || "Gagal menambah temuan", "error");
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal menambah temuan",
        "error"
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleDeleteTemuan = async () => {
    if (!temuanToDelete) return;
    setLoadingDelete(true);
    try {
      const res = await axios.delete(
        `${API_SOISALAK}/temuan/${temuanToDelete.id}`
      );
      if (res.data.success) {
        swal("Sukses", "Temuan berhasil dihapus", "success");
        setShowDeleteConfirm(false);
        setTemuanToDelete(null);
        if (statusUser == 3) {
          ambilTemuan();
        } else {
          ambilTemuanDinas();
        }
      } else {
        swal("Gagal", res.data.message || "Gagal menghapus temuan", "error");
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal menghapus temuan",
        "error"
      );
    } finally {
      setLoadingDelete(false);
    }
  };

  const openEditModal = (item) => {
    setTemuanEdit(item);
    setModalEdit(true);
    setFileName("");
    setSelectedFile(null);
  };

  const handleEditTemuan = async () => {
    if (
      !temuanEdit.temuan ||
      !temuanEdit.idDinas ||
      !temuanEdit.tanggalTemuan ||
      !temuanEdit.tahun
    ) {
      swal(
        "Gagal",
        "Temuan, dinas, tanggal temuan, dan tahun wajib diisi",
        "error"
      );
      return;
    }

    setLoadingEdit(true);
    const formData = new FormData();
    formData.append("temuan", temuanEdit.temuan);
    formData.append("idDinas", temuanEdit.idDinas);
    formData.append("tanggalTemuan", temuanEdit.tanggalTemuan);
    formData.append("deadline", temuanEdit.deadline || "");
    formData.append("idUser", temuanEdit.idUser);
    formData.append("tahun", temuanEdit.tahun);

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      const res = await axios.put(
        `${API_SOISALAK}/temuan/${temuanEdit.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        swal("Sukses", "Temuan berhasil diupdate", "success");
        setModalEdit(false);
        setTemuanEdit(null);
        setSelectedFile(null);
        setFileName("");
        if (statusUser == 3) {
          ambilTemuan();
        } else {
          ambilTemuanDinas();
        }
      } else {
        swal("Gagal", res.data.message || "Gagal mengupdate temuan", "error");
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal mengupdate temuan",
        "error"
      );
    } finally {
      setLoadingEdit(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validasi tipe file
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/jpg",
        "image/png",
      ];
      if (!allowedTypes.includes(file.type)) {
        swal(
          "Gagal",
          "Hanya file PDF, DOC, DOCX, JPG, JPEG, PNG yang diperbolehkan",
          "error"
        );
        e.target.value = null;
        setSelectedFile(null);
        setFileName("");
        return;
      }
      setSelectedFile(file);
      setFileName(file.name);
    } else {
      setSelectedFile(null);
      setFileName("");
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setFileName("");
    // Reset file input
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      input.value = "";
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID");
  };

  const getStatusBadge = (deadline) => {
    if (!deadline)
      return <span className="badge badge-info">Tidak ada deadline</span>;

    const today = new Date();
    const deadlineDate = new Date(deadline);

    if (deadlineDate < today) {
      return <span className="badge badge-danger">Terlambat</span>;
    } else {
      return <span className="badge badge-success">Aktif</span>;
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .custom-spinner {
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #007bff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
          }
        `}
      </style>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <CardTitle tag="h4">Data Temuan {perangkatDaerah}</CardTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Label style={{ margin: 0, fontSize: "14px" }}>
                      Filter Tahun:
                    </Label>
                    <Input
                      type="select"
                      value={tahunTemuan}
                      onChange={(e) => setTahunTemuan(Number(e.target.value))}
                      style={{
                        color: "black",
                        width: "120px",
                        height: "35px",
                        fontSize: "14px",
                      }}
                    >
                      {tahunOptions.map((tahun) => (
                        <option key={tahun} value={tahun}>
                          {tahun}
                        </option>
                      ))}
                    </Input>
                  </div>
                </div>
                {statusUser == 3 ? (
                  <Button
                    color="danger"
                    onClick={() => {
                      setModalTambah(true);
                      setFileName("");
                      setSelectedFile(null);
                    }}
                  >
                    Tambah Temuan
                  </Button>
                ) : null}
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Temuan</th>
                      <th>Dinas</th>
                      <th>Tanggal Temuan</th>
                      <th>Deadline</th>
                      <th>Status</th>
                      <th>Tahun</th>
                      <th>User</th>
                      <th>File</th>
                      {statusUser == 3 ? <th>Aksi</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {loadingTemuan ? (
                      <tr>
                        <td
                          colSpan={10}
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #007bff",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                              }}
                            />
                            <span style={{ color: "#666", fontSize: "14px" }}>
                              Memuat data temuan...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : temuanList && temuanList.length > 0 ? (
                      temuanList.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{idx + 1}</td>
                          <td>{item.temuan}</td>
                          <td>{item.nama_dinas}</td>
                          <td>{formatDate(item.tanggalTemuan)}</td>
                          <td>{formatDate(item.deadline)}</td>
                          <td>{getStatusBadge(item.deadline)}</td>
                          <td>{item.tahun}</td>
                          <td>{item.nama_user}</td>
                          <td>
                            {item.file ? (
                              <a
                                href={`${API_SOISALAK_UPLOAD}${item.file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-info"
                              >
                                Lihat File
                              </a>
                            ) : (
                              "Tidak ada file"
                            )}
                          </td>
                          {statusUser == 3 ? (
                            <td>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => openEditModal(item)}
                                style={{ marginRight: 5 }}
                              >
                                Edit
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => {
                                  setTemuanToDelete(item);
                                  setShowDeleteConfirm(true);
                                }}
                              >
                                Delete
                              </Button>
                            </td>
                          ) : null}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10}>Tidak ada data</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Tambah Temuan */}
        <Modal
          size="lg"
          isOpen={modalTambah}
          toggle={() => setModalTambah(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalTambah(false)}>
            <div>
              <div className="headline-2">Tambah Temuan</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Temuan *
              </Label>
              <Col md={9}>
                <Input
                  type="textarea"
                  value={temuan}
                  onChange={(e) => setTemuan(e.target.value)}
                  placeholder="Uraian temuan"
                  style={{ color: "black" }}
                  rows={4}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Dinas *
              </Label>
              <Col md={9}>
                <Input
                  type="select"
                  value={idDinas}
                  onChange={(e) => setIdDinas(e.target.value)}
                  style={{ color: "black" }}
                  disabled={loadingDinas}
                >
                  <option value="">
                    {loadingDinas ? "Memuat data dinas..." : "- Pilih Dinas -"}
                  </option>
                  {!loadingDinas &&
                    dinasList.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.nama_dinas}
                      </option>
                    ))}
                </Input>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Tanggal Temuan *
              </Label>
              <Col md={9}>
                <Input
                  type="date"
                  value={tanggalTemuan}
                  onChange={(e) => setTanggalTemuan(e.target.value)}
                  style={{ color: "black" }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Deadline
              </Label>
              <Col md={9}>
                <Input
                  type="date"
                  value={deadline}
                  onChange={(e) => setDeadline(e.target.value)}
                  style={{ color: "black" }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Tahun *
              </Label>
              <Col md={9}>
                <Input
                  type="number"
                  value={tahun}
                  onChange={(e) => setTahun(e.target.value)}
                  placeholder="Tahun temuan"
                  style={{ color: "black" }}
                  min="2020"
                  max="2030"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                File Lampiran
              </Label>
              <Col md={9}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    style={{ color: "black", flex: 1 }}
                  />
                  <Button
                    color="info"
                    size="sm"
                    onClick={() =>
                      document.getElementById("fileInputTambah").click()
                    }
                  >
                    Pilih File
                  </Button>
                </div>
                <input
                  id="fileInputTambah"
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                />
                <small className="text-muted">
                  Format: PDF, DOC, DOCX, JPG, JPEG, PNG
                </small>
                {fileName && (
                  <div className="mt-2">
                    <small className="text-info">
                      File yang dipilih: <strong>{fileName}</strong>
                    </small>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={handleRemoveFile}
                      style={{ marginLeft: 10 }}
                    >
                      Hapus File
                    </Button>
                  </div>
                )}
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <Button color="secondary" onClick={() => setModalTambah(false)}>
              Batal
            </Button>
            <Button
              color="primary"
              onClick={handleTambahTemuan}
              disabled={loadingSubmit}
            >
              {loadingSubmit ? (
                <>
                  <div className="custom-spinner" />
                  Menyimpan...
                </>
              ) : (
                "Simpan"
              )}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Konfirmasi Delete */}
        <Modal
          isOpen={showDeleteConfirm}
          toggle={() => setShowDeleteConfirm(false)}
        >
          <ModalHeader toggle={() => setShowDeleteConfirm(false)}>
            Konfirmasi Hapus
          </ModalHeader>
          <ModalBody>
            Apakah Anda yakin ingin menghapus temuan{" "}
            <b>{temuanToDelete?.temuan}</b>?
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setShowDeleteConfirm(false)}
            >
              Batal
            </Button>
            <Button
              color="danger"
              onClick={handleDeleteTemuan}
              disabled={loadingDelete}
            >
              {loadingDelete ? (
                <>
                  <div className="custom-spinner" />
                  Menghapus...
                </>
              ) : (
                "Hapus"
              )}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Edit Temuan */}
        <Modal
          size="lg"
          isOpen={modalEdit}
          toggle={() => setModalEdit(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalEdit(false)}>
            <div>
              <div className="headline-2">Edit Temuan</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Temuan *
              </Label>
              <Col md={9}>
                <Input
                  type="textarea"
                  value={temuanEdit?.temuan || ""}
                  onChange={(e) =>
                    setTemuanEdit({
                      ...temuanEdit,
                      temuan: e.target.value,
                    })
                  }
                  placeholder="Uraian temuan"
                  style={{ color: "black" }}
                  rows={4}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Dinas *
              </Label>
              <Col md={9}>
                <Input
                  type="select"
                  value={temuanEdit?.idDinas || ""}
                  onChange={(e) =>
                    setTemuanEdit({
                      ...temuanEdit,
                      idDinas: e.target.value,
                    })
                  }
                  style={{ color: "black" }}
                  disabled={loadingDinas}
                >
                  <option value="">
                    {loadingDinas ? "Memuat data dinas..." : "- Pilih Dinas -"}
                  </option>
                  {!loadingDinas &&
                    dinasList.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.nama_dinas}
                      </option>
                    ))}
                </Input>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Tanggal Temuan *
              </Label>
              <Col md={9}>
                <Input
                  type="date"
                  value={temuanEdit?.tanggalTemuan || ""}
                  onChange={(e) =>
                    setTemuanEdit({
                      ...temuanEdit,
                      tanggalTemuan: e.target.value,
                    })
                  }
                  style={{ color: "black" }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Deadline
              </Label>
              <Col md={9}>
                <Input
                  type="date"
                  value={temuanEdit?.deadline || ""}
                  onChange={(e) =>
                    setTemuanEdit({
                      ...temuanEdit,
                      deadline: e.target.value,
                    })
                  }
                  style={{ color: "black" }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Tahun *
              </Label>
              <Col md={9}>
                <Input
                  type="number"
                  value={temuanEdit?.tahun || ""}
                  onChange={(e) =>
                    setTemuanEdit({
                      ...temuanEdit,
                      tahun: e.target.value,
                    })
                  }
                  placeholder="Tahun temuan"
                  style={{ color: "black" }}
                  min="2020"
                  max="2030"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                File Lampiran
              </Label>
              <Col md={9}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    style={{ color: "black", flex: 1 }}
                  />
                  <Button
                    color="info"
                    size="sm"
                    onClick={() =>
                      document.getElementById("fileInputEdit").click()
                    }
                  >
                    Pilih File
                  </Button>
                </div>
                <input
                  id="fileInputEdit"
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                />
                <small className="text-muted">
                  Format: PDF, DOC, DOCX, JPG, JPEG, PNG
                </small>
                {fileName && (
                  <div className="mt-2">
                    <small className="text-info">
                      File yang dipilih: <strong>{fileName}</strong>
                    </small>
                  </div>
                )}
                {temuanEdit?.file && !fileName && (
                  <div className="mt-2">
                    <small className="text-info">
                      File saat ini:{" "}
                      <a
                        href={`${API_SOISALAK}${temuanEdit.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {temuanEdit.file.split("/").pop()}
                      </a>
                    </small>
                  </div>
                )}
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <Button color="secondary" onClick={() => setModalEdit(false)}>
              Batal
            </Button>
            <Button
              color="primary"
              onClick={handleEditTemuan}
              disabled={loadingEdit}
            >
              {loadingEdit ? (
                <>
                  <div className="custom-spinner" />
                  Menyimpan...
                </>
              ) : (
                "Simpan"
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default Temuan;
